export default __webpack_public_path__ + "static/media/jan3.1c957801.jpg";